/**
 * Blocks outbound API calls when forceMatch compat check fails.
 * /api/version, /api/health, and /api/ping stay allowed so the checker can recover.
 */

let apiBlocked = false;
let fetchPatched = false;

const ALLOWED_PATH_RE = /\/api\/(version|health|ping)(?:\?|$)/;

export function isApiBlocked(): boolean {
  return apiBlocked;
}

export function setApiBlocked(blocked: boolean): void {
  apiBlocked = blocked;
}

function requestUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  return input.url;
}

function isApiRequest(url: string): boolean {
  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return parsed.pathname.includes('/api/');
  } catch {
    return url.includes('/api/');
  }
}

function isAllowedWhileBlocked(url: string): boolean {
  return ALLOWED_PATH_RE.test(url);
}

/** Install once; safe to call multiple times. */
export function installApiFetchGate(): void {
  if (fetchPatched || typeof window === 'undefined') return;
  fetchPatched = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = requestUrl(input);
    if (apiBlocked && isApiRequest(url) && !isAllowedWhileBlocked(url)) {
      return Promise.reject(new Error('API_VERSION_MISMATCH'));
    }
    return originalFetch(input, init);
  };
}
